export default "__VITE_PUBLIC_ASSET__eeb62624__"